import { createApp } from '@wu/widget-core';
import { meta } from './meta';
import { Weather } from './weather';

export default createApp({ alias: meta.alias, name: meta.name }, Weather);
